<template>
  <b-col>
    <b-card title="Notas Fiscais">
      <b-card
          no-body
          class="mb-3 mt-2"
      >
        <div class="m-1">
          <!-- Table Top -->
          <b-row>
            <b-col
                cols="12"
                md="3"
            />
          </b-row>

        </div>
        <b-table
            class="mt-1"
            :striped="true"
            :bordered="true"
            :hover="true"
            :responsive="true"
            sticky-header
            table-variant="secondary"
            :fields="fields"
            :items="$store.state.PTC_Dashboard.RetornaQTDNotasDashPTC.qtdNotas"
            responsive
            show-empty
            empty-text="Nenhum registro encontrado"
        >
          <!-- A virtual column -->
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <!-- coluna de exclusão virtual -->
          <template #cell(acoes)="data">
            <b-button
                variant="primary"
                size="sm"
                :to="{ name: 'notaFiscal', params: { dataDash } }"
            >
              Detalhes
            </b-button>
          </template>
        </b-table>
      </b-card>
    </b-card>
  </b-col>
</template>
<script>
import { BCard, BCol, BRow } from 'bootstrap-vue';

export default {
  components: {
    BCard,
    BCol,
    BRow,
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      fields: [
        {
          key: 'data',
          label: 'Data',
        },
        {
          key: 'QTD',
          label: 'Qtde. Notas',
        },
        {
          key: 'ValorTotal',
          label: 'Valor Total',
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      dataDash: null,
    };
  },
  methods: {
    atualizaParams(data) {
      this.dataDash = data;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
